import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Platform } from 'ionic-angular';

import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { ToastController } from 'ionic-angular';
import { HomePage } from '../home/home';


@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  private email: any;
  private password: any;
  public loading;
  public farms = [];
  public CowGenderArray = [];
  public CowTypesArray = [];
  public CowStatusesArray = [];
  public BullArray = [];
  public MotherArray = [];
  public farm;
  public loader;

  constructor(public navCtrl: NavController, public navParams: NavParams,
      private rest: RestProvider,
      private data: DataProvider,
      private toastCtrl: ToastController,
      public loadingCtrl: LoadingController,
      public plt: Platform) {
  }

  async stopLoading() {
    return await this.loading.dismiss();
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'bottom',
      duration: 3000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'bottom',
      duration: 3000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }

  ionViewDidLoad() {
    this.rest.farms().subscribe(res => {
      this.farms = res;
      localStorage.setItem('farms', JSON.stringify(this.farms));
    });
  }

  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'hidden';
    document.getElementById('mainHeader').style.display = 'none';
    document.getElementById('backmenu').style.display = 'none';
  }
  showLoader(content?: string) {
    if (this.loader) {
      this.loader.dismiss();
    }
    this.loader = this.loadingCtrl.create({ 
      content: content ? content : "Ачаалж байна..."
    })
    this.loader.present();
    this.loader.onDidDismiss(()=>{
      this.loader = null;
    })
  }
  hideLoader() {
      if(this.loader)
        this.loader.dismiss();
  }
  login(){
    this.showLoader();
    if(this.farm == null || this.farm == '') {
      this.showToast1('Та ферм ээ сонгоно уу.');
      this.hideLoader();
      return;
    }
    if(this.email == null || this.email == '') {
      this.showToast1('Та имэйл ээ оруулна уу.');
      this.hideLoader();
      return;
    }
    if(this.password == null || this.password == '') {
      this.showToast1('Та нууц үгээ оруулна уу.');
      this.hideLoader();
      return;
    }
    // this.rest.Cows(this.farm).subscribe(res=>{});
    this.rest.login(this.email, this.password, this.farm).subscribe(res => {
      if(res == null) {
        this.email = '';
        this.password = '';
        this.showToast1('Нэвтрэх нэр эсвэл нууц үг буруу байна.');
        this.hideLoader();
      } else if(res.result) {
        this.data.userId = res.data.user_id;
        this.data.userName = res.data.username;
        this.data.phone = res.data.phone;
        this.data.email = res.data.email;
        this.data.workYearIn = res.data.start_date;
        this.data.role = res.data.role_name;
        this.data.farm_id = this.farm;
        this.data.password = this.password;
        for(let i = 0; i < this.farms.length; i++) {
          if(this.farms[i].id == this.farm) {
            this.data.farmName = this.farms[i].farm_name;
          }
        }
        localStorage.setItem('email',this.data.email);
        localStorage.setItem('password',this.data.password);
        localStorage.setItem('farmId',this.data.farm_id);
        localStorage.setItem('login', JSON.stringify(res));
        this.navCtrl.setRoot(HomePage);
        this.hideLoader();
      } else {
        if(res.msg == 'incorrect') {
          this.password = '';
          this.showToast1('Нэвтрэх нэр эсвэл нууц үг буруу байна.');
          this.hideLoader();
        } else {
          this.farm = null;
          this.showToast1('Танд хамаарах ферм биш байна.');
          this.hideLoader();
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts